import { render, staticRenderFns } from "./inbound-product-modal.vue?vue&type=template&id=a2c781c2&scoped=true&"
import script from "./inbound-product-modal.vue?vue&type=script&lang=js&"
export * from "./inbound-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./inbound-product-modal.vue?vue&type=style&index=0&id=a2c781c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c781c2",
  null
  
)

export default component.exports